import { createBrowserRouter } from 'react-router-dom'

import RootLayout from '@/layout/default.tsx'
import BobLanding from '@/views/BobLanding'
import CreavoLanding from '@/views/CreavoLanding'
import Home from '@/views/Home'
import Login from '@/views/Login'
import Pricing from '@/views/Pricing'
import VisualDetail from '@/views/VisualDetail'
import Visuals from '@/views/Visuals'

const router = createBrowserRouter(
  [
    {
      path: '',
      element: <RootLayout />,
      children: [
        {
          path: '/',
          element: <Home />,
        },
        {
          path: '/bob',
          element: <BobLanding />,
        },
        {
          path: '/creavo',
          element: <CreavoLanding />,
        },
        {
          path: '/pricing',
          element: <Pricing />,
        },
        {
          path: '/login',
          element: <Login />,
        },
        {
          path: '/home/:userName',
          element: <Visuals />,
        },
        {
          path: '/visual/:channelId',
          element: <VisualDetail />,
        },
      ],
    },
  ],
  { basename: import.meta.env.VITE_PUBLIC_PATH as string },
)

export default router
